/**
 * 히어로 상단 라벨.
 *
 * 히어로 이미지는 두지 않는다. 225개 지역 페이지가 한 장을 공용으로 쓰면
 * 지역별 내용과 무관한 장식이 되고, 특정 시설 사진을 쓰면 그 시설 광고로 읽힌다.
 * 이 페이지에서 먼저 보여야 하는 것은 요금 숫자다.
 */
export const REGION_HERO_EYEBROW = "빈소 비용, 주차, 시설 정보 한눈에 알아보기";
